import { AbstractControl } from '@angular/forms';
import {LoggerService} from "@bequeathed/ngx-app-core";

const LOG: LoggerService = LoggerService.get('CheckboxValidator');

/**
 * Set of validators for checkboxes
 *
 * @author Dan Bennett (dbennett)
 */
export class CheckboxValidator {

    static requiredCheckboxGroupValidator(control: AbstractControl): Record<string, boolean> | null {
        LOG.trace('requiredCheckboxGroupValidator', `Validating checkbox value: = ${control.value}`);
        if (control.value) {
            for (const value of control.value) {
                if (value) {
                    return null;
                }
            }
        }

        return { 'unchecked': true };
    }

    static singleRequiredCheckboxGroupValidator(control: AbstractControl): Record<string, boolean> | null {
        LOG.trace('singleRequiredCheckboxGroupValidator', `Validating checkbox value: = ${control.value}`);
        let selectedCount = 0;
        for (const value of control.value) {
            if (value) {
                selectedCount++;
            }

            if (selectedCount > 1) {
                return { 'multiple': true };
            }
        }
        return selectedCount === 0 ? { 'unchecked': true } : null;
    }
}

